import React, { memo, useState } from 'react';
import { Spin, Button } from 'antd';

function ResentEmailBodyCell({ record, resentEmail }) {
  const [isLoading, setIsLoading] = useState(false);
  const disabled = record.inviteStatus === 'Accepted';
  const resend_flag =
    record.inviteStatus === 'invited' ||
    record.inviteStatus === 'Invited' ||
    // (record.inviteStatus === 'accepted' && record.lastVisit == null) ||
    record.inviteStatus === 'failed' ||
    record.inviteStatus === 'Failed';

  return (
    <Spin spinning={isLoading}>
      <u
        className={disabled ? 'disabled-btn ' : ''}
        onClick={async () => {
          if (disabled) {
            return;
          }
          try {
            setIsLoading(true);
            await resentEmail([record]);
            setIsLoading(false);
          } catch (err) {
            console.log(err);
          }
        }}
      >
        {resend_flag ? <Button>Resend Invite</Button> : ''}
      </u>
    </Spin>
  );
}

export default memo(ResentEmailBodyCell);
